import { ChangeEvent, useRef } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/types";

export const UploadFileButton = ({
  onChange,
  file,
  buttonText,
  ...rest
}: {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  file: File;
  buttonText?: string;
  placement?: Placement;
  delay?: any;
}) => {
  const fileInputRef = useRef<HTMLInputElement>();
  
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" data-testid="test-tooltip" hidden={!file} {...props}>
      {file?.name}
    </Tooltip>
  )

  const showIcon = () => !!file ? (
    <i className="bi bi-check2"></i>
  ) : (
    <i className="bi bi-question"></i>
  );
  
  return (<>
    <OverlayTrigger
      placement={rest.placement || "bottom"}
      delay={rest.delay || { show: 250, hide: 100 }}
      overlay={renderTooltip}
    >
      <Button type="button" variant={`${!file ? 'outline-' : ''}primary`} size="lg" className="me-3" onClick={() => fileInputRef.current.click()}>
        {`${buttonText || 'Subir archivo'}`} {showIcon()}
      </Button>
    </OverlayTrigger>
    <Form.Control type="file" hidden ref={fileInputRef} accept="text/csv" data-testid={"upload-field"} onChange={onChange}/>
  </>);
}